
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";
import { TeamCard } from "./TeamCard";
import { Team } from "../types";
import { useNavigate } from "react-router-dom";
import { useUserRoles } from "@/hooks/useUserRoles";
import { FolderOpen } from "lucide-react";

interface TeamListProps {
  teams?: Team[];
  isLoading: boolean;
}

export const TeamList = ({ teams, isLoading }: TeamListProps) => {
  const navigate = useNavigate();
  const { isAdmin } = useUserRoles();

  // Debug: log teams data to see its structure
  console.log("TeamList in reports page received:", teams);

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fadeIn">
        {Array.from({ length: 6 }).map((_, index) => (
          <Card key={index} className="animate-fadeIn">
            <CardContent className="p-6 space-y-4">
              <Skeleton className="h-12 w-12 rounded-lg" />
              <div className="space-y-2">
                <Skeleton className="h-6 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (!teams || teams.length === 0) {
    return (
      <div className="col-span-full animate-fadeIn">
        <Card className="border-dashed">
          <CardContent className="p-10 text-center flex flex-col items-center gap-3 text-muted-foreground">
            <FolderOpen className="h-8 w-8 text-muted-foreground" />
            <p>
              {isAdmin 
                ? "No teams found. Please create a team first to manage reports."
                : "You are not assigned to any teams. Please contact an administrator."}
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fadeIn">
      {teams.map((team) => (
        <TeamCard
          key={team.id}
          team={team}
          onClick={() => navigate(`/reports/team/${team.id}`)}
          canEdit={isAdmin} // Pass isAdmin as canEdit prop
        />
      ))}
    </div>
  );
};
